<script>
export default {

    props : ["formations"]
}
</script>

<template>

        <div class="row">
          <div class="col-md-4">
            <ul class="mt-3" >

                <a href="" 
        v-for="item in formations"
        :key="item.id">
                <li class="mb-2" >
                  <div class="card" styles="width: 18rem;">
                    <div class="card-body">
                      <h5 class="card-title">{{ item.title }}</h5>
                      <h6 class="card-subtitle mb-2 text-muted">{{ item.short_desc }}</h6>
                      <p class="card-text">short desc</p>
                      <a href="#" class="card-link">Sauvegarder</a>
                    </div>
                  </div>

                </li>
                </a>
            </ul>
          </div>

        </div> 

</template>